<template>
  <div class="setup">
    <div class="config">
      <div class="config-box">
        <div class="config-step-title">
          <div class="step-item active" @click="curStep = 1">
            <span>1</span>
            管理节点
          </div>
          <div class="step-item" :class="curStep >= 2 ? 'active' : ''" @click="curStep = 2">
            <span>2</span>
            登录节点
          </div>
          <div class="step-item" :class="curStep >= 3 ? 'active' : ''" @click="curStep = 3">
            <span>3</span>
            计算节点
          </div>
          <div class="step-item" :class="curStep >= 4 ? 'active' : ''" @click="curStep = 4">
            <span>4</span>
            存储节点
          </div>
          <div class="step-item" :class="curStep >= 5 ? 'active' : ''" @click="curStep = 5">
            <span>5</span>
            网络
          </div>
          <div class="step-item" :class="curStep == 6 ? 'active' : ''" @click="curStep = 6">
            <span>6</span>
            总结
          </div>
        </div>
        <div class="config-step-cont">
          <el-form ref="form" :model="form" label-width="80px">
            <div class="step-cont" :class="curStep == 1 ? 'active' : ''" @click="curStep = 1">
              <el-row :gutter="10">
                <el-col :span="10">
                  <el-form-item label="配置机型">
                    <el-select v-model="form.managementNode.setupMachine" placeholder="配置机型">
                      <el-option v-for="(type, index) in formSelections.setupMachine" :key="index + type" :label="type" :value="type"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="配置数量">
                    <el-input-number :min="0" v-model="form.managementNode.numberMachine"></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>
              <h4>单台配置如下：</h4>
              <el-row :gutter="10">
                <el-col :span="10">
                  <el-form-item label="CPU" prop="setupCPU">
                    <el-select v-model="form.managementNode.setupCPU" placeholder="请选择CPU">
                      <el-option v-for="(type, index) in formSelections.setupCPU" :key="index + type" :label="type.split('|')[0]" :value="type"></el-option>
                    </el-select>
                    <p>{{form.managementNode.setupCPU.split('|')[1]}}</p>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="数量">
                    <el-input-number :min="0" v-model="form.managementNode.numberCPU"></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="10">
                  <el-form-item label="内存" prop="setupMemery">
                    <el-select v-model="form.managementNode.setupMemery" placeholder="请选择内存">
                      <el-option v-for="(type, index) in formSelections.setupMemery" :key="index + type" :label="type" :value="type"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="数量">
                    <el-input-number :min="0" v-model="form.managementNode.numberMemery"></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10" v-for="(setupNetwork, index) in form.managementNode.setupNetworks" :key="index + 'network'">
                <el-col :span="10">
                  <el-form-item :label="index == 0 ? '网络' : ''" prop="type">
                    <el-select v-model="setupNetwork.type" placeholder="请选择网络">
                      <el-option v-for="(type, index) in formSelections.setupNetwork" :key="index + type" :label="type" :value="type"></el-option>
                    </el-select>
                    <i class="el-icon-plus" @click="networkPlus(form.managementNode)"></i>
                    <i v-if="index != 0" class="el-icon-minus" @click="networkMinus(form.managementNode, index)"></i>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="数量">
                    <el-input-number :min="0" v-model="setupNetwork.number"></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10" v-for="(setupHardDisk, index) in form.managementNode.setupHardDisks" :key="index + 'harddisk'">
                <el-col :span="10">
                  <el-form-item :label="index == 0 ? '硬盘' : ''" prop="type">
                    <el-select v-model="setupHardDisk.type" placeholder="请选择网络">
                      <el-option v-for="(type, index) in formSelections.setupHardDisk" :key="index + type" :label="type" :value="type"></el-option>
                    </el-select>
                    <i class="el-icon-plus" @click="hardDiskPlus(form.managementNode)"></i>
                    <i v-if="index != 0" class="el-icon-minus" @click="hardDiskMinus(form.managementNode, index)"></i>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="数量">
                    <el-input-number :min="0" v-model="setupHardDisk.number"></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10" v-for="(setupGPU, index) in form.managementNode.setupGPUs" :key="index + 'gpu'">
                <el-col :span="10">
                  <el-form-item :label="index == 0 ? 'GPU' : ''" prop="type">
                    <el-select v-model="setupGPU.type" placeholder="请选择GPU">
                      <el-option v-for="(type, index) in formSelections.setupGPU" :key="index + type" :label="type" :value="type"></el-option>
                    </el-select>
                    <i class="el-icon-plus" @click="gpuPlus(form.managementNode)"></i>
                    <i v-if="index != 0" class="el-icon-minus" @click="gpuMinus(form.managementNode, index)"></i>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="数量">
                    <el-input-number :min="0" v-model="setupGPU.number"></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <div class="step-cont" :class="curStep == 2 ? 'active' : ''" @click="curStep = 2">
              <el-row :gutter="10">
                <el-col :span="10">
                  <el-form-item label="配置机型">
                    <el-select v-model="form.loginNode.setupMachine" placeholder="配置机型">
                      <el-option v-for="(type, index) in formSelections.setupMachine" :key="index + type" :label="type" :value="type"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="配置数量">
                    <el-input-number :min="0" v-model="form.loginNode.numberMachine"></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>
              <h4>单台配置如下：</h4>
              <el-row :gutter="10">
                <el-col :span="10">
                  <el-form-item label="CPU" prop="setupCPU">
                    <el-select v-model="form.loginNode.setupCPU" placeholder="请选择CPU">
                      <el-option v-for="(type, index) in formSelections.setupCPU" :key="index + type" :label="type.split('|')[0]" :value="type"></el-option>
                    </el-select>
                    <p>{{ form.loginNode.setupCPU.split('|')[1] }}</p>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="数量">
                    <el-input-number :min="0" v-model="form.loginNode.numberCPU"></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="10">
                  <el-form-item label="内存" prop="setupMemery">
                    <el-select v-model="form.loginNode.setupMemery" placeholder="请选择内存">
                      <el-option v-for="(type, index) in formSelections.setupMemery" :key="index + type" :label="type" :value="type"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="数量">
                    <el-input-number :min="0" v-model="form.loginNode.numberMemery"></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10" v-for="(setupNetwork, index) in form.loginNode.setupNetworks" :key="index + 'network'">
                <el-col :span="10">
                  <el-form-item :label="index == 0 ? '网络' : ''" prop="type">
                    <el-select v-model="setupNetwork.type" placeholder="请选择网络">
                      <el-option v-for="(type, index) in formSelections.setupNetwork" :key="index + type" :label="type" :value="type"></el-option>
                    </el-select>
                    <i class="el-icon-plus" @click="networkPlus(form.loginNode)"></i>
                    <i v-if="index != 0" class="el-icon-minus" @click="networkMinus(form.loginNode, index)"></i>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="数量">
                    <el-input-number :min="0" v-model="setupNetwork.number"></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10" v-for="(setupHardDisk, index) in form.loginNode.setupHardDisks" :key="index + 'harddisk'">
                <el-col :span="10">
                  <el-form-item :label="index == 0 ? '硬盘' : ''" prop="type">
                    <el-select v-model="setupHardDisk.type" placeholder="请选择网络">
                      <el-option v-for="(type, index) in formSelections.setupHardDisk" :key="index + type" :label="type" :value="type"></el-option>
                    </el-select>
                    <i class="el-icon-plus" @click="hardDiskPlus(form.loginNode)"></i>
                    <i v-if="index != 0" class="el-icon-minus" @click="hardDiskMinus(form.loginNode, index)"></i>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="数量">
                    <el-input-number :min="0" v-model="setupHardDisk.number"></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10" v-for="(setupGPU, index) in form.loginNode.setupGPUs" :key="index + 'gpu'">
                <el-col :span="10">
                  <el-form-item :label="index == 0 ? 'GPU' : ''" prop="type">
                    <el-select v-model="setupGPU.type" placeholder="请选择GPU">
                      <el-option v-for="(type, index) in formSelections.setupGPU" :key="index + type" :label="type" :value="type"></el-option>
                    </el-select>
                    <i class="el-icon-plus" @click="gpuPlus(form.loginNode)"></i>
                    <i v-if="index != 0" class="el-icon-minus" @click="gpuMinus(form.loginNode, index)"></i>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="数量">
                    <el-input-number :min="0" v-model="setupGPU.number"></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>

            <div class="step-cont" :class="curStep == 3 ? 'active' : ''" @click="curStep = 3">
              <el-row :gutter="10">
                <el-col :span="10">
                  <el-form-item label="配置机型">
                    <el-select v-model="form.computeNode.setupMachine" placeholder="配置机型">
                      <el-option v-for="(type, index) in formSelections.setupMachine" :key="index + type" :label="type" :value="type"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="配置数量">
                    <el-input-number :min="0" v-model="form.computeNode.numberMachine"></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>
              <h4>单台配置如下：</h4>
              <el-row :gutter="10">
                <el-col :span="10">
                  <el-form-item label="CPU" prop="setupCPU">
                    <el-select v-model="form.computeNode.setupCPU" placeholder="请选择CPU">
                      <el-option v-for="(type, index) in formSelections.setupCPU" :key="index + type" :label="type.split('|')[0]" :value="type"></el-option>
                    </el-select>
                    <p>{{ form.computeNode.setupCPU.split('|')[1] }}</p>
                    <p>理论浮点运算能力: {{getGFlops()}}  GFlops</p>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="数量">
                    <el-input-number :min="0" v-model="form.computeNode.numberCPU"></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="10">
                  <el-form-item label="内存" prop="setupMemery">
                    <el-select v-model="form.computeNode.setupMemery" placeholder="请选择内存">
                      <el-option v-for="(type, index) in formSelections.setupMemery" :key="index + type" :label="type" :value="type"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="数量">
                    <el-input-number :min="0" v-model="form.computeNode.numberMemery"></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10" v-for="(setupNetwork, index) in form.computeNode.setupNetworks" :key="index + 'network'">
                <el-col :span="10">
                  <el-form-item :label="index == 0 ? '网络' : ''" prop="type">
                    <el-select v-model="setupNetwork.type" placeholder="请选择网络">
                      <el-option v-for="(type, index) in formSelections.setupNetwork" :key="index + type" :label="type" :value="type"></el-option>
                    </el-select>
                    <i class="el-icon-plus" @click="networkPlus(form.computeNode)"></i>
                    <i v-if="index != 0" class="el-icon-minus" @click="networkMinus(form.computeNode, index)"></i>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="数量">
                    <el-input-number :min="0" v-model="setupNetwork.number"></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10" v-for="(setupHardDisk, index) in form.computeNode.setupHardDisks" :key="index + 'harddisk'">
                <el-col :span="10">
                  <el-form-item :label="index == 0 ? '硬盘' : ''" prop="type">
                    <el-select v-model="setupHardDisk.type" placeholder="请选择网络">
                      <el-option v-for="(type, index) in formSelections.setupHardDisk" :key="index + type" :label="type" :value="type"></el-option>
                    </el-select>
                    <i class="el-icon-plus" @click="hardDiskPlus(form.computeNode)"></i>
                    <i v-if="index != 0" class="el-icon-minus" @click="hardDiskMinus(form.computeNode, index)"></i>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="数量">
                    <el-input-number :min="0" v-model="setupHardDisk.number"></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10" v-for="(setupGPU, index) in form.computeNode.setupGPUs" :key="index + 'gpu'">
                <el-col :span="10">
                  <el-form-item :label="index == 0 ? 'GPU' : ''" prop="type">
                    <el-select v-model="setupGPU.type" placeholder="请选择GPU">
                      <el-option v-for="(type, index) in formSelections.setupGPU" :key="index + type" :label="type" :value="type"></el-option>
                    </el-select>
                    <i class="el-icon-plus" @click="gpuPlus(form.computeNode)"></i>
                    <i v-if="index != 0" class="el-icon-minus" @click="gpuMinus(form.computeNode, index)"></i>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="数量">
                    <el-input-number :min="0" v-model="setupGPU.number"></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>

            <div class="step-cont" :class="curStep == 4 ? 'active' : ''" @click="curStep = 4">
              <el-row :gutter="20" style="margin:0;line-height: 40px;">
                <el-col :span="5" style="text-align:center">
                  <el-radio v-model="form.storageNode.setupType" label="U3100"></el-radio>
                </el-col>
                <el-col :span="5" style="text-align:center">
                  <el-radio v-model="form.storageNode.setupType" label="U3200"></el-radio>
                </el-col>
                <el-col :span="5" style="text-align:center">
                  <el-radio v-model="form.storageNode.setupType" label="U5000"></el-radio>
                </el-col>
                <el-col :span="5">
                  <el-form-item label="数量">
                    <el-input-number :min="0" v-model="form.storageNode.numberStorage"></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>
              <h4 style="text-align:center">{{form.storageNode.setupType == 'U3100' ? formSelections.setupFri : (form.storageNode.setupType == 'U3200' ? formSelections.setupSed : formSelections.setupThr)}}</h4>

              <el-row :gutter="10" v-show="form.storageNode.setupType == 'U3100'">
                <el-col :span="10">
                  <el-form-item label="控制器缓存" prop="setupCache" label-width="85px">
                    <el-select v-model="form.storageNode.setupCache" placeholder="请选择缓存">
                      <el-option v-for="(type ,index) in formSelections.setupCache" :key="index + type" :label="type.split('|')[0]" :value="type"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="10" v-for="(setupDisk, index) in form.storageNode.setupDisks" :key="index + 'disks'" v-show="form.storageNode.setupType == 'U3100'">
                <el-col :span="10">
                  <el-form-item :label="index == 0 ? '控制器硬盘' : ''" prop="type" label-width="85px">
                    <el-select v-model="setupDisk.type" placeholder="请选择硬盘">
                      <el-option v-for="(type, index) in formSelections.setupDisk" :key="index + type" :label="type" :value="type"></el-option>
                    </el-select>
                    <i class="el-icon-plus" @click="diskPlus(form.storageNode)"></i>
                    <i v-if="index != 0" class="el-icon-minus" @click="diskMinus(form.storageNode, index)"></i>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="单台数量">
                    <el-input-number :min="0" v-model="setupDisk.number"></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="10" v-show="form.storageNode.setupType == 'U3200'  || form.storageNode.setupType == 'U5000' ">
                <el-col :span="10">
                  <el-form-item label="双控制器缓存" prop="setupDual" label-width="100px">
                    <el-select v-model="form.storageNode.setupDual" placeholder="请选择缓存">
                      <el-option v-for="(type ,index) in formSelections.setupDual" :key="index + type" :label="type.split('|')[0]" :value="type"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

             <el-row :gutter="10">
                <el-col :span="10">
                  <el-form-item label="扩展柜类型" prop="setupExpansion" label-width="85px">
                    <el-select v-model="form.storageNode.setupExpansion" placeholder="请选择缓存">
                      <el-option v-for="(type ,index) in formSelections.setupExpansion" :key="index + type" :label="type.split('|')[0]" :value="type"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="数量">
                    <el-input-number :min="0" v-model="form.storageNode.numberExpansion"></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>

             <el-row :gutter="10" v-for="(setupExcabinet, index) in form.storageNode.setupExcabinets" :key="index + 'excabinets'">
                <el-col :span="10">
                  <el-form-item :label="index == 0 ? '扩展柜硬盘' : ''" prop="type" label-width="85px">
                    <el-select v-model="setupExcabinet.type" placeholder="请选择硬盘">
                      <el-option v-for="(type, index) in formSelections.setupExcabinet" :key="index + type" :label="type" :value="type"></el-option>
                    </el-select>
                    <i class="el-icon-plus" @click="excabinetPlus(form.storageNode)"></i>
                    <i v-if="index != 0" class="el-icon-minus" @click="excabinetMinus(form.storageNode, index)"></i>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="单台数量">
                    <el-input-number :min="0" v-model="setupExcabinet.number"></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>
              
            </div>

            <div class="step-cont" :class="curStep == 5 ? 'active' : ''" @click="curStep = 5">
              <el-tabs type="card" :stretch="true">
                <el-tab-pane>
                  <span slot="label"><el-checkbox v-model="form.networkNode.setupSwitchsSelect" true-label="万兆网络"></el-checkbox> 万兆网络</span>
                  <el-row :gutter="10" v-for="(setupSwitch,index) in form.networkNode.setupSwitchs" :key="index + 'switchs'">
                    <el-col :span="12">
                        <el-form-item :label="index == 0 ? '交换机型号' : ''" prop="type" label-width="85px">
                          <el-select v-model="setupSwitch.type" placeholder="请选择型号">
                            <el-option v-for="(type,index) in formSelections.setupSwitch" :key="index + type" :label="type.split('|')[0]" :value="type"></el-option>
                          </el-select>
                          <i class="el-icon-plus" @click="switchPlus(form.networkNode)"></i>
                          <i v-if="index != 0" class="el-icon-minus" @click="switchMinus(form.networkNode, index)"></i>
                          <p>{{setupSwitch.type.split("|")[1]}}</p>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="单台数量">
                        <el-input-number :min="0" v-model="setupSwitch.number"></el-input-number>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-tab-pane>
                <el-tab-pane><span slot="label"><el-checkbox v-model="form.networkNode.setupSwitchsMellanoxsSelect" true-label="Mellanox Infiniband网络"></el-checkbox> Mellanox Infiniband网络</span>
                  <el-row :gutter="10" v-for="(setupMellanox,index) in form.networkNode.setupSwitchsMellanoxs" :key="index + 'mellanox'">
                    <el-col :span="12">
                        <el-form-item :label="index == 0 ? '交换机型号' : ''" prop="type" label-width="85px">
                          <el-select v-model="setupMellanox.type" placeholder="请选择型号">
                            <el-option v-for="(type,index) in formSelections.setupMellanox" :key="index + type" :label="type.split('|')[0]" :value="type"></el-option>
                          </el-select>
                          <i class="el-icon-plus" @click="mellanoxPlus(form.networkNode)"></i>
                          <i v-if="index != 0" class="el-icon-minus" @click="mellanoxMinus(form.networkNode, index)"></i>
                          <p>{{setupMellanox.type.split('|')[1]}}</p>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="单台数量">
                        <el-input-number :min="0" v-model="setupMellanox.number"></el-input-number>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-tab-pane>
                <el-tab-pane><span slot="label"><el-checkbox v-model="form.networkNode.setupSwitchsIntelsSelect" true-label="intel OPA网络"></el-checkbox> intel OPA网络</span>
                  <el-row :gutter="10" v-for="(setupIntel,index) in form.networkNode.setupSwitchsIntels" :key="index + 'intel'">
                    <el-col :span="12">
                        <el-form-item :label="index == 0 ? '交换机型号' : ''" prop="type" label-width="85px">
                          <el-select v-model="setupIntel.type" placeholder="请选择型号">
                            <el-option v-for="(type,index) in formSelections.setupIntel" :key="index + type" :label="type.split('|')[0]" :value="type"></el-option>
                          </el-select>
                          <i class="el-icon-plus" @click="intelPlus(form.networkNode)"></i>
                          <i v-if="index != 0" class="el-icon-minus" @click="intelMinus(form.networkNode, index)"></i>
                          <p>{{setupIntel.type.split('|')[1]}}</p>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="单台数量">
                        <el-input-number :min="0" v-model="setupIntel.number"></el-input-number>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-tab-pane>
                <el-tab-pane>
                  <span slot="label"><el-checkbox v-model="form.networkNode.setupSwitchsThousandSelect" true-label="千兆网络"></el-checkbox> 千兆网络</span>
                  <el-row :gutter="10" v-for="(setupSwitch,index) in form.networkNode.setupSwitchsThousand" :key="index + 'switchs'">
                    <el-col :span="12">
                        <el-form-item :label="index == 0 ? '交换机型号' : ''" prop="type" label-width="85px">
                          <el-select v-model="setupSwitch.type" placeholder="请选择型号">
                            <el-option v-for="(type,index) in formSelections.setupSwitchThousand" :key="index + type" :label="type.split('|')[0]" :value="type"></el-option>
                          </el-select>
                          <i class="el-icon-plus" @click="switchThousandPlus(form.networkNode)"></i>
                          <i v-if="index != 0" class="el-icon-minus" @click="switchThousandMinus(form.networkNode, index)"></i>
                          <p>{{setupSwitch.type.split("|")[1]}}</p>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="单台数量">
                        <el-input-number :min="0" v-model="setupSwitch.number"></el-input-number>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-tab-pane>
              </el-tabs>
             
            </div>

            <div class="step-cont" :class="curStep == 6 ? 'active' : ''" @click="curStep = 6">
              <el-row :gutter="30">
                <el-col :span="8" v-if="form.managementNode.numberMachine > 0">
                  <h4>管理节点<span class="right">{{form.managementNode.numberMachine}}台</span></h4>
                  <template>
                    <h5>配置机型: <span>{{form.managementNode.setupMachine}}</span></h5>
                    <h5 v-if="form.managementNode.numberCPU > 0">处理器: <span>{{form.managementNode.numberCPU}} * {{form.managementNode.setupCPU.split('|')[0]}} <br/>{{form.managementNode.setupCPU.split('|')[1]}}</span></h5>
                    <h5 v-if="form.managementNode.numberMemery > 0">内存: <span>{{form.managementNode.numberMemery}} * {{form.managementNode.setupMemery}}</span></h5>
                    <h5 v-if="form.managementNode.setupNetworks.length > 0">网络: <span v-if="network.number > 0" v-for="(network, index) in form.managementNode.setupNetworks" :key="index + network.type">{{network.number}} * {{network.type}}</span></h5>
                    <h5 v-if="form.managementNode.setupHardDisks.length > 0">硬盘: <span v-if="harddisk.number > 0" v-for="(harddisk, index) in form.managementNode.setupHardDisks" :key="index + harddisk.type">{{harddisk.number}} * {{harddisk.type}}</span></h5>
                    <h5 v-if="form.managementNode.setupGPUs.map(s => s.number).reduce((t, s) => t + s) > 0">GPU: <span v-if="gpu.number > 0" v-for="(gpu, index) in form.managementNode.setupGPUs" :key="index + gpu.type">{{gpu.number}} * {{gpu.type}}</span></h5>
                  </template>
                </el-col>
                <el-col :span="8" v-if="form.loginNode.numberMachine > 0">
                  <h4>登录节点<span class="right">{{form.loginNode.numberMachine}}台</span></h4>
                  <template>
                    <h5>配置机型: <span>{{form.loginNode.setupMachine}}</span></h5>
                    <h5 v-if="form.loginNode.numberCPU > 0">处理器: <span>{{form.loginNode.numberCPU}} * {{form.loginNode.setupCPU.split('|')[0]}} <br/>{{form.loginNode.setupCPU.split('|')[1]}}</span></h5>
                    <h5 v-if="form.loginNode.numberMemery > 0">内存: <span>{{form.loginNode.numberMemery}} * {{form.loginNode.setupMemery}}</span></h5>
                    <h5 v-if="form.loginNode.setupNetworks.map(s => s.number).reduce((t, s) => t + s) > 0">网络: <span v-if="network.number > 0" v-for="(network, index) in form.loginNode.setupNetworks" :key="index + network.type">{{network.number}} * {{network.type}}</span></h5>
                    <h5 v-if="form.loginNode.setupHardDisks.map(s => s.number).reduce((t, s) => t + s) > 0">硬盘: <span v-if="harddisk.number > 0" v-for="(harddisk, index) in form.loginNode.setupHardDisks" :key="index + harddisk.type">{{harddisk.number}} * {{harddisk.type}}</span></h5>
                    <h5 v-if="form.loginNode.setupGPUs.map(s => s.number).reduce((t, s) => t + s) > 0">GPU: <span v-if="gpu.number > 0" v-for="(gpu, index) in form.loginNode.setupGPUs" :key="index + gpu.type">{{gpu.number}} * {{gpu.type}}</span></h5>
                  </template>
                </el-col>
                <el-col :span="8" v-if="form.computeNode.numberMachine > 0">
                  <h4>计算节点<span class="right">{{form.computeNode.numberMachine}}台</span></h4>
                  <template>
                    <h5>配置机型: <span>{{form.computeNode.setupMachine}}</span></h5>
                    <h5 v-if="form.computeNode.numberCPU > 0">处理器: <span>{{form.computeNode.numberCPU}} * {{form.computeNode.setupCPU.split('|')[0]}} <br/>{{form.computeNode.setupCPU.split('|')[1]}}</span></h5>
                    <h5 v-if="form.computeNode.numberMemery > 0">内存: <span>{{form.computeNode.numberMemery}} * {{form.computeNode.setupMemery}}</span></h5>
                    <h5 v-if="form.computeNode.setupNetworks.map(s => s.number).reduce((t, s) => t + s) > 0">网络: <span v-if="network.number > 0" v-for="(network, index) in form.computeNode.setupNetworks" :key="index + network.type">{{network.number}} * {{network.type}}</span></h5>
                    <h5 v-if="form.computeNode.setupHardDisks.map(s => s.number).reduce((t, s) => t + s) > 0">硬盘: <span v-if="harddisk.number > 0" v-for="(harddisk, index) in form.computeNode.setupHardDisks" :key="index + harddisk.type">{{harddisk.number}} * {{harddisk.type}}</span></h5>
                    <h5 v-if="form.computeNode.setupGPUs.map(s => s.number).reduce((t, s) => t + s) > 0">GPU: <span v-if="gpu.number > 0" v-for="(gpu, index) in form.computeNode.setupGPUs" :key="index + gpu.type">{{gpu.number}} * {{gpu.type}}</span></h5>
                  </template>
                </el-col>

                <el-col :span="8">
                  <h4>存储节点<span class="right">{{form.storageNode.numberStorage}}台</span></h4>
                  <template>
                    <h5>型号: <span>{{form.storageNode.setupType}}</span></h5>
                    <h5 v-show="form.storageNode.setupType == 'U3100'">缓存: <span>{{form.storageNode.setupCache.split('|')[0]}}</span></h5>
                    <h5 v-show="form.storageNode.setupType == 'U3100'" v-if="form.storageNode.setupDisks.map(s => s.number).reduce((t, s) => t + s) > 0">硬盘:<span v-if="disks.number > 0" v-for="(disks, index) in form.storageNode.setupDisks" :key="index + disks.type">{{disks.number}} * {{disks.type}}</span></h5>
                    <h5 v-show="form.storageNode.setupType != 'U3100'">双控制器缓存:<span style="width:70%">{{form.storageNode.setupDual}}</span></h5>
                    <h5 v-if="form.storageNode.numberExpansion > 0">扩展柜: <span>{{form.storageNode.numberExpansion}} * {{form.storageNode.setupExpansion}}</span></h5>
                    <h5 v-if="form.storageNode.setupExcabinets.map(s => s.number).reduce((t, s) => t + s) > 0">扩展柜硬盘:<span style="width:70%" v-if="excabinets.number > 0" v-for="(excabinets, index) in form.storageNode.setupExcabinets" :key="index + excabinets.type">{{excabinets.number}} * {{excabinets.type}}</span></h5>
                  </template>
                </el-col>

                <el-col :span="8">
                  <!-- <h4>网络<span class="right"></span></h4> -->
                  <template>
                    <h4 v-if="form.networkNode.setupSwitchsSelect">网络:<span>万兆网络</span></h4>
                    <h5 v-if="form.networkNode.setupSwitchsSelect && form.networkNode.setupSwitchs.map(s => s.number).reduce((t, s) => t + s) > 0">交换机型号:<span style="width:70%" v-if="switchs.number > 0" v-for="(switchs, index) in form.networkNode.setupSwitchs" :key="index + switchs.type">{{switchs.number}} * {{switchs.type.split('|')[0]}}<br/>{{switchs.type.split('|')[1]}}</span></h5>
                    
                    <h4 v-if="form.networkNode.setupSwitchsMellanoxsSelect">网络:<span>Mellanox Infiniband网络</span></h4>
                    <h5 v-if="form.networkNode.setupSwitchsMellanoxsSelect && form.networkNode.setupSwitchsMellanoxs.map(s => s.number).reduce((t, s) => t + s) > 0">交换机型号:<span style="width:70%" v-if="mellanox.number > 0" v-for="(mellanox, index) in form.networkNode.setupSwitchsMellanoxs" :key="index + mellanox.type">{{mellanox.number}} * {{mellanox.type.split('|')[0]}}<br/>{{mellanox.type.split('|')[1]}}</span></h5>

                    <h4 v-if="form.networkNode.setupSwitchsIntelsSelect">网络:<span>intel OPA网络</span></h4>
                    <h5 v-if="form.networkNode.setupSwitchsIntelsSelect && form.networkNode.setupSwitchsIntels.map(s => s.number).reduce((t, s) => t + s) > 0">交换机型号:<span style="width:70%" v-if="intel.number > 0" v-for="(intel, index) in form.networkNode.setupSwitchsIntels" :key="index + intel.type">{{intel.number}} * {{intel.type.split('|')[0]}}<br/>{{intel.type.split('|')[1]}}</span></h5>

                    <h4 v-if="form.networkNode.setupSwitchsThousandSelect">网络:<span>千兆网络</span></h4>
                    <h5 v-if="form.networkNode.setupSwitchsThousandSelect && form.networkNode.setupSwitchsThousand.map(s => s.number).reduce((t, s) => t + s) > 0">交换机型号:<span style="width:70%" v-if="switchs.number > 0" v-for="(switchs, index) in form.networkNode.setupSwitchsThousand" :key="index + switchs.type">{{switchs.number}} * {{switchs.type.split('|')[0]}}<br/>{{switchs.type.split('|')[1]}}</span></h5>
                  </template>
                </el-col>
              </el-row>
            </div>
          </el-form>
        </div>
        <div class="config-step-footer">
          <el-button v-if="curStep < 6" @click="curStep = 6">确定</el-button>
          <el-button v-if="curStep < 5" type="primary" @click="curStep = curStep + 1 > 6 ? 6 : curStep + 1">下一步</el-button>
          <el-button v-if="curStep == 5" type="primary" @click="curStep = 6">完成</el-button>
          <el-button v-if="curStep == 6" type="primary" @click="downloadWord">下载word</el-button>
        </div>
      </div>
    </div>
    
		<div class="footer">
			<div class="footer-cont">
        <div class="logo">
          <img src="@/assets/imgs/logo.png"/>
        </div>
        <div class="contact">
          <h4>联系我们</h4>
          <p>地址：南京市江北新区腾飞大厦A座4楼</p>
          <p>电话：025-68155007</p>
        </div>
        <div class="qr">
          <img class="tu" src="@/assets/imgs/home-qr.png"/><br />
          <span class="spa">关注我们</span>
        </div>
			</div>
		</div>
    <div class="footer footer2">
      <p>版权所有 © 南京信易达计算技术有限公司 <a style="color: rgba(255,255,255, .4);" href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">苏ICP备2021021510号-1</a> 苏公网安备 0000000000号</p>
    </div>
  </div>
</template>

<script>
import store from '../store.js'
import 'animate.css'

import Docxtemplater from 'docxtemplater'
import PizZip from 'pizzip'
import JSZipUtils from 'jszip-utils'
import {saveAs} from 'file-saver'

import template1 from '../assets/template1.docx'
import axios from 'axios'

export default {
  name: "home",
  data() {
    return {
      act:1,
      state: store.state,
      isShow:false,
      curStep: 1,
      formSelections: { // 选项设置
        setupMachine: [ // 配置机型选项
          '机型1', '机型2'
        ],
        setupCPU: [ // CPU选项
          'AMD 7442|核数64；主频2.3GHz;睿频3.0GHz;缓存256M', 'intel 6230R|核数24；主频3.0GHz;睿频4.0GHz;缓存128M'
        ],
        setupMemery: [ // 内存选项
          '16G DDR4', '32G DDR4'
        ],
        setupNetwork: [ // 网络选项
          'Mellanox 100Gb infiniband HCA卡', '16Gb FC HBA卡'
        ],
        setupHardDisk: [ // 硬盘选项
          '300Gb HDD', '480Gb SSD'
        ],
        setupGPU:[//GPU选项
          // 'GPU1','GPU2','GPU3'
        ],
        setupFri:'',//存储节点U3100
        setupSed:'',//存储节点U3200
        setupThr:'',//存储节点U5000
        setupFloat: 0,//理论浮点定制
        setupCache:[//控制器缓存
          // '64G DDR4 ','128G DDR4','256G DDR4'
        ],
        setupDual:[//双控制器缓存
          // '64G DDR4 ','128G DDR4','256G DDR4'
        ],
        setupDisk:[//控制器硬盘
          // '1.92T SSD','10T HDD','14T HDD'
        ],
        setupExpansion:[//扩展柜类型
          // '2U12盘位','4U24盘位','4U60盘位'
        ],
        setupExcabinet:[//扩展柜硬盘
          // '1.92T SSD','10T HDD','14T HDD'
        ],
        setupSwitch:[// 万兆网络交换机型号
          // 'SX6012','SX6024'
        ],
        setupSwitchThousand: [],// 千兆网络交换机型号
        setupMellanox:[//Mellanox网络

        ],
        setupIntel:[//intel OPA网络

        ],
      },
      form: {
        // 管理节点
        managementNode: {
          setupMachine: '', // 配置机型
          numberMachine: 0, // 配置数量
          setupCPU: '', // CPU
          numberCPU: 0, // CPU数量
          setupMemery: '', // 内存
          numberMemery: 0, // 内存数量
          setupNetworks: [ // 网络列表 可多选
            {
              type: '', // 类型
              number: 0, // 数量
            }
          ],
          setupHardDisks: [ // 硬盘列表 可多选
            {
              type: '', // 类型
              number: 0, // 数量
            }
          ],
           setupGPUs: [ //GPU 可多选
            {
              type:'', //类型
              number: 0,//数量
            }
          ],
        },
        // 登录节点
        loginNode: {
          setupMachine: '', // 配置机型
          numberMachine: 0, // 配置数量
          setupCPU: '', // CPU
          numberCPU: 0, // CPU数量
          setupMemery: '', // 内存
          numberMemery: 0, // 内存数量
          setupNetworks: [ // 网络列表 可多选
            {
              type: '', // 类型
              number: 0, // 数量
            }
          ],
          setupHardDisks: [ // 硬盘列表 可多选
            {
              type: '', // 类型
              number: 0, // 数量
            }
          ],
          setupGPUs: [ //GPU 可多选
            {
              type:'', //类型
              number: 0,//数量
            }
          ],
        },
        // 计算节点
        computeNode: {
          setupMachine: '', // 配置机型
          numberMachine: 0, // 配置数量
          setupCPU: '', // CPU
          numberCPU: 0, // CPU数量
          setupMemery: '', // 内存
          numberMemery: 0, // 内存数量
          setupNetworks: [ // 网络列表 可多选
            {
              type: '', // 类型
              number: 0, // 数量
            }
          ],
          setupHardDisks: [ // 硬盘列表 可多选
            {
              type: '', // 类型
              number: 0, // 数量
            }
          ],
          setupGPUs: [ //GPU 可多选
            {
              type:'', //类型
              number: 0,//数量
            }
          ],
          
        },
        //存储节点
        storageNode: {
          setupType: 'U3100',//存储节点radio
          numberStorage:0,//存储节点数量
          setupCache:'',//控制器缓存
          setupDual:'',//双控制缓存
          setupDisks:[//控制器硬盘 可多选
            {
              type:'',//类型
              number:0,//数量
            }
          ],
          setupExpansion:'',//扩展柜类型
          numberExpansion:'',//扩展柜数量
          setupExcabinets:[//扩展柜硬盘
            {
              type:'',//类型
              number:0,//数量
            }
          ]
        },
        //网络节点
        networkNode:{
          // setupNetType:'万兆网络',//网络节点radio
          setupSwitchsSelect: false,
          setupSwitchsThousandSelect: false,
          setupSwitchsMellanoxsSelect: false,
          setupSwitchsIntelsSelect: false,
          setupSwitchs:[// 万兆网络交换机型号 可多选
            {
              type:'',//类型
              number:0,//数量
            }
          ],
          setupSwitchsThousand:[// 千兆网络交换机型号 可多选
            {
              type:'',//类型
              number:0,//数量
            }
          ],
          setupSwitchsMellanoxs:[//Mellanox网络 可多选
            {
              type:'',//类型
              number:0,//数量
            }
          ],
          setupSwitchsIntels:[//intel OPA网络 可多选
            {
              type:'',//类型
              number:0,//数量
            }
          ],
        },
      }
    };
  },
  watch: {
    'state.scrollTop' (val, oldVal) {
      console.log('home scrollTop:', val, oldVal)
    }
  },
  created() {
    var me = this
    axios.post('http://form.mixwechat.com/api/interface/info/data/', {
        _id: '60d598034c92a54a760b7e70'
      })
      .then(function (response) {
        // debugger
        response = response.data
        if (response.code == 200 && response.data.data.length > 0) {
          me.formSelections.setupMachine = response.data.data.find(d => d.setupname == '配置机型')['setup'].split(/[\,，]/g)
          me.formSelections.setupCPU = response.data.data.find(d => d.setupname == 'CPU')['setup'].split(/[\,，]/g)
          me.formSelections.setupMemery = response.data.data.find(d => d.setupname == '内存')['setup'].split(/[\,，]/g)
          me.formSelections.setupNetwork = response.data.data.find(d => d.setupname == '网络')['setup'].split(/[\,，]/g)
          me.formSelections.setupHardDisk = response.data.data.find(d => d.setupname == '硬盘')['setup'].split(/[\,，]/g)
          me.formSelections.setupCache = response.data.data.find(d => d.setupname == '控制器缓存')['setup'].split(/[\,，]/g)
          me.formSelections.setupDual = response.data.data.find(d => d.setupname == '双控制器缓存')['setup'].split(/[\,，]/g)
          me.formSelections.setupDisk = response.data.data.find(d => d.setupname == '控制器硬盘')['setup'].split(/[\,，]/g)
          me.formSelections.setupExpansion = response.data.data.find(d => d.setupname == '扩展柜类型')['setup'].split(/[\,，]/g)
          me.formSelections.setupExcabinet = response.data.data.find(d => d.setupname == '扩展柜硬盘')['setup'].split(/[\,，]/g)
          me.formSelections.setupSwitch = response.data.data.find(d => d.setupname == '万兆网络交换机型号')['setup'].split(/[\,，]/g)
          me.formSelections.setupSwitchThousand = response.data.data.find(d => d.setupname == '千兆网络交换机型号')['setup'].split(/[\,，]/g)
          me.formSelections.setupGPU = response.data.data.find(d => d.setupname == 'GPU')['setup'].split(/[\,，]/g)
          me.formSelections.setupFloat = response.data.data.find(d => d.setupname == '理论浮点定制变量')['setup']
          me.formSelections.setupMellanox = response.data.data.find(d => d.setupname == 'Mellanox网络交换机型号')['setup'].split(/[\,，]/g)
          me.formSelections.setupIntel = response.data.data.find(d => d.setupname == 'intel OPA网络交换机型号')['setup'].split(/[\,，]/g)
          me.formSelections.setupFri = response.data.data.find(d => d.setupname == 'U3100')['setup']
          me.formSelections.setupSed = response.data.data.find(d => d.setupname == 'U3200')['setup']
          me.formSelections.setupThr = response.data.data.find(d => d.setupname == 'U5000')['setup']
        } else {
          me.$message.error('用户名或密码错误');
        }
      })
      .catch(function (error) {
        me.$message.error('服务器出错，请稍后再试');
      })
  },
  methods: {
    networkPlus(node) { // 增加网络
      node.setupNetworks.push({
        type: '', // 网络类型
        number: 0, // 网络数量
      })
    },
    networkMinus(node, index) { // 减少网络
      node.setupNetworks.splice(index, 1);
    },
    hardDiskPlus(node) { // 增加硬盘
      node.setupHardDisks.push({
        type: '', // 硬盘类型
        number: 0, // 硬盘数量
      })
    },
    hardDiskMinus(node, index) { // 减少硬盘
      node.setupHardDisks.splice(index, 1)
    },
    diskPlus(node) { //控制器硬盘增加
      node.setupDisks.push({
        type:'',//控制器个数
        number:0,//控制器数量
      })
    },
    diskMinus(node, index){//控制器硬盘减少
      node.setupDisks.splice(index, 1)
    },
    gpuPlus(node) { //GPU增加
      node.setupGPUs.push({
        type:'',//GPU个数
        number:0,//GPU数量
      })
    },
    gpuMinus(node, index){ //减少GPU
      node.setupGPUs.splice(index, 1)
    },
    excabinetPlus(node) { //扩展柜硬盘增加
      node.setupExcabinets.push({
        type:'',//扩展柜硬盘个数
        number:0,//扩展柜硬盘数量
      })
    },
    excabinetMinus(node, index){//控制器硬盘减少
      node.setupExcabinets.splice(index, 1)
    },
    switchPlus(node) {
      node.setupSwitchs.push({//扩展柜硬盘增加
        type:'',//扩展柜硬盘个数
        number:0,//扩展柜硬盘数量
      })
    },
    switchMinus(node, index){//扩展柜硬盘减少
      node.setupSwitchs.splice(index, 1)
    },
    mellanoxPlus(node) {
      node.setupSwitchsMellanoxs.push({//Mellanox网络增加
        type:'',//Mellanox网络个数
        number:0//Mellanox网络数量
      })
    },
    mellanoxMinus(node,index){//Mellanox网络减少
      node.setupSwitchsMellanoxs.splice(index,1)
    },
    intelPlus(node) {
      node.setupSwitchsIntels.push({//intel OPA网络增加
        type:'',//intel OPA网络个数
        number:0//intel OPA网络数量
      })
    },
    intelMinus(node,index){//intel OPA网络减少
      node.setupSwitchsIntels.splice(index,1)
    },
    switchThousandPlus(node) {
      node.setupSwitchsThousand.push({//扩展柜硬盘增加
        type:'',//扩展柜硬盘个数
        number:0,//扩展柜硬盘数量
      })
    },
    switchThousandMinus(node, index){//扩展柜硬盘减少
      node.setupSwitchsThousand.splice(index, 1)
    },
    getGFlops() {
      if (!this.form.computeNode.setupCPU) {
        return 0
      }
      return /核数(\d+)/g.exec(this.form.computeNode.setupCPU)[1] * this.form.computeNode.numberCPU * this.form.computeNode.numberMachine * this.formSelections.setupFloat * /主频([\d.]+)/g.exec(this.form.computeNode.setupCPU)[1]
    },
    downloadWord() { // 下载word
      var toObj = {
        "managementType": this.form.managementNode.setupMachine,
        "managementNum": this.form.managementNode.numberMachine,
        "managementCPU": (this.form.managementNode.numberCPU > 0 ? this.form.managementNode.numberCPU + ' * ' + this.form.managementNode.setupCPU : '-'),
        "managementMemery": (this.form.managementNode.numberMemery > 0 ? this.form.managementNode.numberMemery + ' * ' + this.form.managementNode.setupMemery : '-'),
        "managementNetworks": this.buildText(this.form.managementNode.setupNetworks),
        "managementHardDisks": this.buildText(this.form.managementNode.setupHardDisks),
        "managementGPU":this.buildText(this.form.managementNode.setupGPUs, 'GPU：'),
        "loginType": this.form.loginNode.setupMachine,
        "loginNum": this.form.loginNode.numberMachine,
        "loginCPU": (this.form.loginNode.numberCPU > 0 ? this.form.loginNode.numberCPU + ' * ' + this.form.loginNode.setupCPU : '-'),
        "loginMemery": (this.form.loginNode.numberMemery > 0 ? this.form.loginNode.numberMemery + ' * ' + this.form.loginNode.setupMemery : '-'),
        "loginNetworks": this.buildText(this.form.loginNode.setupNetworks),
        "loginHardDisks": this.buildText(this.form.loginNode.setupHardDisks),
        "loginGPU":this.buildText(this.form.loginNode.setupGPUs, 'GPU：'),
        "computeType": this.form.computeNode.setupMachine,
        "computeNum": this.form.computeNode.numberMachine,
        "GFlops": this.getGFlops(),
        "computeCPU": (this.form.computeNode.numberCPU > 0 ? this.form.computeNode.numberCPU + ' * ' + this.form.computeNode.setupCPU : '-'),
        "computeMemery": (this.form.computeNode.numberMemery > 0 ? this.form.computeNode.numberMemery + ' * ' + this.form.computeNode.setupMemery : '-'),
        "computeNetworks": this.buildText(this.form.computeNode.setupNetworks),
        "computeHardDisks": this.buildText(this.form.computeNode.setupHardDisks),
        "computeGPU":this.buildText(this.form.computeNode.setupGPUs, 'GPU：'),
        "storeType": this.form.storageNode.setupType,
        "storeCacheSum": this.buildStoreCacheSum(this.form.storageNode),
        "storeNum": this.form.storageNode.numberStorage,
        "storeDesc": this.form.storageNode.setupType == 'U3100' ? this.formSelections.setupFri : (this.form.storageNode.setupType == 'U3200' ? this.formSelections.setupSed : this.formSelections.setupThr),
        "storeCache": (this.form.storageNode.setupType == 'U3100' ? "控制器缓存：" + this.form.storageNode.setupCache : "双控制器缓存：" + this.form.storageNode.setupDual),
        "storeDisks": (this.form.storageNode.setupType == 'U3100' ? "控制器硬盘：" + this.buildText(this.form.storageNode.setupDisks) : ''),
        "storeExpansion": (this.form.storageNode.numberExpansion > 0 ? this.form.storageNode.numberExpansion + ' * ' + this.form.storageNode.setupExpansion : '-'),
        "storeExpansions": this.buildText(this.form.storageNode.setupExcabinets),
        // "networkType": this.form.networkNode.setupNetType,
        // "networkSwitchs": this.buildText(this.form.networkNode.setupNetType == '万兆网络' ? this.form.networkNode.setupSwitchs : (this.form.networkNode.setupNetType == 'Mellanox Infiniband网络' ? this.form.networkNode.setupSwitchsMellanoxs : this.form.networkNode.setupSwitchsIntels))
        "networkType1": '',
        "networkType1Unit": '',
        "networkType1Num": '',
        "networkSwitchs1": '',
        "networkType2": '',
        "networkType2Unit": '',
        "networkType2Num": '',
        "networkSwitchs2": '',
        "networkType3": '',
        "networkType3Unit": '',
        "networkType3Num": '',
        "networkSwitchs3": '',
        "networkType4": '',
        "networkType4Unit": '',
        "networkType4Num": '',
        "networkSwitchs4": '',
        "networkType": '' // (this.form.networkNode.setupSwitchsSelect ? '万兆网络、' : '') + (this.form.networkNode.setupSwitchsMellanoxsSelect ? 'Mellanox Infiniband网络、' : '') + (this.form.networkNode.setupSwitchsIntelsSelect ? 'intel OPA网络、' : '') + (this.form.networkNode.setupSwitchsThousandSelect ? '千兆网络、' : '').replace(/、/g, '')
      }

      // 生成选中网络列表
      var saveNetworks = []
      if (this.form.networkNode.setupSwitchsSelect) {
        saveNetworks.push({
          type: '万兆网络',
          unit: '台',
          num: this.form.networkNode.setupSwitchs.map(s => s.number).reduce((t, s) => t + s),
          switchs: this.buildText(this.form.networkNode.setupSwitchs, '交换机型号：')
        })
      }
      if (this.form.networkNode.setupSwitchsMellanoxsSelect) {
        saveNetworks.push({
          type: 'Mellanox Infiniband网络',
          unit: '台',
          num: this.form.networkNode.setupSwitchsMellanoxs.map(s => s.number).reduce((t, s) => t + s),
          switchs: this.buildText(this.form.networkNode.setupSwitchsMellanoxs, '交换机型号：')
        })
      }
      if (this.form.networkNode.setupSwitchsIntelsSelect) {
        saveNetworks.push({
          type: 'intel OPA网络',
          unit: '台',
          num: this.form.networkNode.setupSwitchsIntels.map(s => s.number).reduce((t, s) => t + s),
          switchs: this.buildText(this.form.networkNode.setupSwitchsIntels, '交换机型号：')
        })
      }
      if (this.form.networkNode.setupSwitchsThousandSelect) {
        saveNetworks.push({
          type: '千兆网络',
          unit: '台',
          num: this.form.networkNode.setupSwitchsThousand.map(s => s.number).reduce((t, s) => t + s),
          switchs: this.buildText(this.form.networkNode.setupSwitchsThousand, '交换机型号：')
        })
      }

      var saveNames = []
      saveNetworks.forEach((n, idx) => {
        toObj['networkType' + (idx + 1)] = n.type
        toObj['networkType' + (idx + 1) + 'Unit'] = n.unit
        toObj['networkType' + (idx + 1) + 'Num'] = n.num
        toObj['networkSwitchs' + (idx + 1)] = n.switchs
        saveNames.push(n.type)
      })

      toObj['networkType'] = saveNames.join('、')

      console.log('toObj: ', toObj)
      this.exportDocx(template1, toObj, '项目方案.docx')
    },
    buildText(arr, prefix) {
      var toStr = []
      arr.filter(a => a.number > 0).forEach(a => {
        toStr.push(a.number + ' * ' + a.type)
      })
      if (!prefix) {
        return toStr.length > 0 ? toStr.join(' + ') : '-'
      }
      return toStr.length > 0 ? prefix + toStr.join(' + ') : ''
    },
    // 存储容量计算
    buildStoreCacheSum(storeNode) {
      var toArr = []
      if (storeNode.setupType == 'U3100') {
        storeNode.setupDisks.filter(a => a.number > 0).forEach(a => {
          toArr.push(a.type.replace(/[^\d.]/g, '') + '*' + a.number)
        })
      }

      storeNode.setupExcabinets.filter(a => a.number > 0).forEach(a => {
        toArr.push(a.type.replace(/[^\d.]/g, '') + '*' + a.number)
      })

      return toArr.join('+')
    },
    exportDocx(tempDocxPath, data, fileName) {
      // 读取并获得模板文件的二进制内容
      JSZipUtils.getBinaryContent(tempDocxPath, (error, content) => {
        if (error) {
          throw error
        }
        const zip = new PizZip(content)
        const doc = new Docxtemplater().loadZip(zip)
        doc.setData(data)
        try {
          // render the document (replace all occurences of {first_name} by John, {last_name} by Doe, ...)
          doc.render()
        } catch (error) {
          const e = {
            message: error.message,
            name: error.name,
            stack: error.stack,
            properties: error.properties
          }
          console.log({
            error: e
          })
          // The error thrown here contains additional information when logged with JSON.stringify (it contains a property object).
          throw error
        }
        const out = doc.getZip().generate({
          type: 'blob',
          mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        }) // Output the document using Data-URI
        saveAs(out, fileName)
      })
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.config {
  margin-top: 50px;
  min-height: 800px;
  padding: 20px 0 50px;
  background-color: #F2F2F2;
  .config-box {
    width: 1200px;
    margin: 0 auto;
    background-color: #fff;
    .config-step-title {
      height: 50px;
      line-height: 50px;
      color:rgba(0, 0, 0, .45);
      border-bottom: 1px solid rgba(0, 0, 0, .15);
      font-size: 16px;
      padding-right: 200px;
      display: flex;
      .step-item {
        flex: 1;
        padding-left: 50px;
        line-height: 30px;
        cursor: pointer;
        &:hover {
          background-color: rgba(0, 0, 0, .02);
        }
        // &::after {
        //   content: '';
        //   display: inline-block;
        //   width: 40px;
        //   height: 1px;
        //   background: rgba(0, 0, 0, .5);
        //   margin-left: 20px;
        //   position: relative;
        //   top: -5px;
        // }
        span {
          display: inline-block;
          width: 24px;
          height: 24px;
          font-size: 12px;
          box-sizing: border-box;
          line-height: 24px;
          text-align: center;
          border-radius: 12px;
          margin-top: 13px;
          margin-right: 5px;
          border: 1px solid rgba(0, 0, 0, .35);
        }
        &.active {
          color: #1890FF;
          span {
            border-color: #1890FF;
            color: #fff;
            background-color: #1890FF;
          }
        }
      }
    }
    .config-step-cont {
      padding: 20px;
      .step-cont {
        display: none;
        &.active {
          display: block;
        }

        h4 {
          font-weight: normal;
          padding: 10px;
          margin-bottom: 10px;
          border-top: 1px solid rgba(0, 0, 0, .04);
          background-color: rgba(0, 0, 0, .02);
          span {
            float: right;
          }
        }
        h5 {
          font-weight: normal;
          font-size: 14px;
          padding: 10px;
          overflow: hidden;
          width: 100%;
          box-sizing: border-box;
          span {
            float: right;
            text-align: right;
            width: 82%;
          }
        }
        p {
          font-size: 14px;
        }
        i {
          font-size: 20px;
          margin-left: 10px;
          cursor: pointer;
         
        }
      }
      border-bottom: 1px solid rgba(0, 0, 0, .15);
    }
    .config-step-footer {
      padding: 20px;
      text-align: right;
    }
  }
}
.footer {
  background: #2B2B2B;
  // height: 100px;
  font-size: 14px;
  color: rgba(255,255,255, .4);
  .footer-cont {
    display: flex;
    width: 1200px;
    margin: 0 auto;
    .logo {
      width: 130px;
      padding: 20px 0 0;
      img {
        width: 120px;
        background: rgba(255, 255, 255, .9);
        padding: 5px 8px;
        border-radius: 5px;
      }
    }
    .contact {
      flex: 1;
      padding: 20px 0 0 10%;
      line-height: 26px;
      h4 {
        color: rgba(255,255,255, .69);
        font-size: 16px;
        padding-bottom: 10px;
      }
    }
    .qr {
      width: 80px;
      padding: 20px 0;
      text-align: center;
      img {
        width: 80px;
        margin-bottom: 10px;
      }
    }
  }
}
.footer2 {
  background: #2B2B2B;
  height: 30px;
  line-height: 30px;
  border-top: 1px solid rgba(255,255,255,.1);
  text-align: center;
  color: rgba(255,255,255,.4);
  font-size: 12px;
}

</style>



// WEBPACK FOOTER //
// src/components/Setup.vue